export default "__VITE_PUBLIC_ASSET__043cce47__"